import { CSSObject } from '@chakra-ui/react';

export const TextItem: CSSObject = {
  textTransform: 'uppercase',
  fontFamily: 'heading',
  color: 'white',
  fontSize: 'sm',
  fontWeight: 'semibold',
};
